import * as React from 'react';

export function useWebSocket({ url, messageCallback, openCallback, closeCallback }) {
    const urlRef = React.useRef(url)
    const messageCallbackRef = React.useRef(messageCallback)
    const openCallbackRef = React.useRef(openCallback)
    const closeCallbackRef = React.useRef(closeCallback)

    React.useEffect(() => {
        let websocket;
        let timerKey;
        let opend;

        const onConnect = () => {
            const ws = new WebSocket(urlRef.current);
            ws.onopen = (e) => {
                opend = true
                console.log('socket open');
                if(openCallbackRef?.current)
                    openCallbackRef.current(e);
            };
            ws.onmessage = (e) => {
                //console.log(JSON.parse(e.data));
                if(messageCallbackRef?.current)
                    messageCallbackRef.current(e);                
            };
            ws.onclose = (e) => {
                if(opend && closeCallbackRef?.current){
                    closeCallbackRef.current(e);                    
                }
                opend = false
                timerKey = setTimeout(() => {
                    //console.log('socket try connecting');
                    websocket.onopen = null;
                    websocket.onmessage = null;
                    websocket.onclose = null;
                    websocket = onConnect();
                }, 5000);
            };
            return ws;
        }

        websocket = onConnect();

        return () => {
            if (timerKey)
                clearTimeout(timerKey);

            if (websocket) {
                websocket.onopen = null;
                websocket.onmessage = null;
                websocket.onclose = null;
                websocket.close();
            }
            console.log('socket dispose');
        };
    }, [urlRef, messageCallbackRef, openCallbackRef]);
}